import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

import { State, City } from "country-state-city";

import PageTitle from "../../layouts/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { createAudience } from "../../../store/actions/AudienceActions";
import {
  create,
  get,
  updateAction,
} from "../../../store/actions/CommonActions";
import { GET_VENUE } from "../../../store/actions/VenueTypes";
import CustomTextarea from "../../components/Forms/CustomInputs/CustomTextarea";
import CustomImageUpload from "../../components/Forms/CustomInputs/CustomImageUpload";

const isSaveSuccess = (response) =>
  response?.data?.success === true ||
  response?.status === 200 ||
  response?.status === 201;

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Please enter name"),
  venue_id: Yup.string().required("Please select a Venue"),
  venuelabel: Yup.string().required("Please select a Venue label"),
  capacity: Yup.number()
    .required("Please enter capacity")
    .integer("Capacity must be a whole number")
    .min(1, "Capacity must be at least 1")
    .max(1000000, "Max allowed capacity reached"),
  entries: Yup.number()
    .required("Please enter No. of Entries")
    .integer("No. of Entries must be a whole number")
    .min(1, "No. of Entries must be at least 1")
    .max(999, "No. of Entries cannot exceed 999"),
  capacity_alert1: Yup.number()
    .required("Capacity Alert 1 is required")
    .integer("Capacity Alert 1 must be a whole number")
    .min(0, "Capacity Alert 1 must be at least 0")
    .max(100, "Capacity Alert 1 cannot exceed 100"),
  capacity_alert2: Yup.number()
    .required("Capacity Alert 2 is required")
    .integer("Capacity Alert 2 must be a whole number")
    .min(0, "Capacity Alert 2 must be at least 0")
    .max(100, "Capacity Alert 2 cannot exceed 100"),
  location: Yup.string()
    .required("Google Location Link is required")
    .url("Invalid URL"),
  description: Yup.string()
    .required("Description is required")
    // .max(200, "Description must be at most 200 characters"),
    .test(
      "maxWords",
      "Description must be at most 200 words",
      function (value) {
        if (!value) return true; // required handles empty
        const wordCount = value.trim().split(/\s+/).length;
        return wordCount <= 200;
      }
    ),
});

const AddUpdateShowVenues = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let initialValues = {
    title: "",
    venue_id: "",
    venuelabel: "",
    capacity: "",
    entries: "",
    capacity_alert1: "",
    capacity_alert2: "",
    location: "",
    description: "",
  };
  if (state) {
    // console.log('svnusiebv')
    initialValues = {
      ...state,
      venue_id: state.venue_id._id,
      venuelabel: state.venue_id.title,
    };
  }

  useEffect(() => {
    dispatch(get("venue", {}, GET_VENUE));
  }, []);

  const tmpData = useSelector((state) => state.venue);
  const { data: venueListing } = tmpData;
  let venueOptions = [];
  if (venueListing && venueListing.length > 0) {
    venueOptions = venueListing.map((v) => {
      return { label: v.title, value: v._id };
    });
  }
  // console.log("snviosuenvsev", location.state);
  return (
    <Fragment>
      <PageTitle />

      <div className="row">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {state?._id ? "Edit" : "Add"} New Stage
              </h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      setSubmitting(true);
                      let response;
                      if (state) {
                        response = await updateAction(
                          `performanceVenue/${state._id}`,
                          "performanceVenue",
                          values
                        );
                      } else {
                        response = await create(
                          "performanceVenue",
                          "initiatitve",
                          values
                        );
                      }
                      if (isSaveSuccess(response)) {
                        navigate("/show-venues", { replace: true });
                      }
                    } catch (error) { }
                    finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div
                          className={`form-group col-md-12 mb-3 ${errors.title ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            Name of the Stage
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="input form-control"
                            name="title"
                          />
                          {errors.title && (
                            <div
                              id="val-title-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.title}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-12 mb-3 ${errors.venue ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">Where is it?</label>
                          <Select
                            value={{
                              label: values.venuelabel,
                              value: values.venue_id,
                            }}
                            onChange={(selectedOption) => {
                              setFieldValue("venue_id", selectedOption.value);
                              setFieldValue("venuelabel", selectedOption.label);
                            }}
                            onBlur={() =>
                              setFieldValue("touched.venue_id", true)
                            }
                            options={venueOptions}
                            name="venue_id"
                            style={{
                              lineHeight: "40px",
                              color: "#7e7e7e",
                              paddingLeft: " 15px",
                            }}
                            classNames={{
                              control: (state) => "form-control p-0 select-custom-css", // add your class here
                            }}
                          />
                          {errors.venue_id && (
                            <div
                              id="val-city-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.venue_id}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-6 mb-3 ${errors.capacity ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">Capacity</label>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              // Remove all non-digit characters (only allow 0-9)
                              const numericValue = value.replace(/[^0-9]/g, '');
                              
                              // Allow empty value for deletion, or valid integer within range
                              if (numericValue === "" || (parseInt(numericValue) >= 1 && parseInt(numericValue) <= 10000000)) {
                                setFieldValue("capacity", numericValue);
                              }
                            }}
                            onBlur={handleBlur}
                            value={values.capacity}
                            className="input form-control"
                            name="capacity"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.capacity && (
                            <div
                              id="val-capacity-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.capacity}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-6 mb-3 ${errors.entries ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            No. of Entries to the Stage
                          </label>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              // Remove all non-digit characters (only allow 0-9)
                              const numericValue = value.replace(/[^0-9]/g, '');
                              
                              // Allow empty value for deletion, or valid integer within range
                              if (numericValue === "" || (parseInt(numericValue) >= 1 && parseInt(numericValue) <= 999)) {
                                setFieldValue("entries", numericValue);
                              }
                            }}
                            onBlur={handleBlur}
                            value={values.entries}
                            className="input form-control"
                            name="entries"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.entries && (
                            <div
                              id="val-entries-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.entries}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-6 mb-3 ${errors.capacity_alert1 ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            Capacity Alert 1 (%)
                          </label>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              // Remove all non-digit characters (only allow 0-9)
                              const numericValue = value.replace(/[^0-9]/g, '');
                              
                              // Remove leading zeros (e.g., "01" becomes "1", but "0" stays "0")
                              const cleanValue = numericValue === "" ? "" : String(parseInt(numericValue, 10) || 0);
                              
                              // Allow empty value for deletion, or valid integer within range
                              if (cleanValue === "" || (parseInt(cleanValue) >= 0 && parseInt(cleanValue) <= 100)) {
                                setFieldValue("capacity_alert1", cleanValue);
                              }
                            }}
                            onBlur={handleBlur}
                            value={values.capacity_alert1}
                            className="input form-control"
                            name="capacity_alert1"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.capacity_alert1 && (
                            <div
                              id="val-capacity_alert1-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.capacity_alert1}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-6 mb-3 ${errors.capacity_alert2 ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            Capacity Alert 2 (%)
                          </label>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              // Remove all non-digit characters (only allow 0-9)
                              const numericValue = value.replace(/[^0-9]/g, '');
                              
                              // Remove leading zeros (e.g., "01" becomes "1", but "0" stays "0")
                              const cleanValue = numericValue === "" ? "" : String(parseInt(numericValue, 10) || 0);
                              
                              // Allow empty value for deletion, or valid integer within range
                              if (cleanValue === "" || (parseInt(cleanValue) >= 0 && parseInt(cleanValue) <= 100)) {
                                setFieldValue("capacity_alert2", cleanValue);
                              }
                            }}
                            onBlur={handleBlur}
                            value={values.capacity_alert2}
                            className="input form-control"
                            name="capacity_alert2"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.capacity_alert2 && (
                            <div
                              id="val-capacity_alert2-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.capacity_alert2}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-12 mb-3 ${errors.location ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            Google Location Link
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.location}
                            className="input form-control"
                            name="location"
                          />
                          {errors.location && (
                            <div
                              id="val-location-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.location}
                            </div>
                          )}
                        </div>

                        <CustomImageUpload
                          fieldName="banner"
                          value={values.banner}
                          error={errors.banner}
                          label={
                            "Upload Cover Image (16:9 / e.g. 800px X 450px)"
                          }
                          classes={"col-md-12"}
                          handleBlur={handleBlur}
                          inputType={"text"}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                        />

                        <CustomTextarea
                          errors={errors}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          values={values}
                        />
                      </div>

                      <div className="float-end">
                        <button
                          type="submit"
                          className="btn me-2 btn-primary"
                          disabled={isSubmitting}
                        >
                          Save
                        </button>
                      </div>
                      {/* <button className="btn btn-danger light">Cancel</button> */}
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddUpdateShowVenues;
